/** This utility appends dispensary to a store name if it doesn't already include it */
export const appendDispensaryToStoreName = (
  storeName: string,
  dispensaryString: string
) =>
  storeName.toLowerCase().includes('dispensary')
    ? storeName
    : `${storeName}${dispensaryString}`;
